export default __webpack_public_path__ + "static/media/infobanner1.db42eacc.svg";